var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`amount-translated amount-translated--${_vm.translate}`},[(_vm.isPending)?_c('span',[_vm._v(" "+_vm._s(`${_vm.isSingle() ? "" : `/ ${_vm.$options.filters.money(_vm.payment.amount)} `}${_vm.$t( "of-debt" )}`)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }